import { Toaster, Position } from '@blueprintjs/core'

export const Toast = Toaster.create({
  className: `toast`,
  position: Position.TOP,
})
